import type { QueryFunctionContext } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { adminJobsKeys } from 'app/queries/adminJobs/adminJobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminJobsKeys.cloneTargets>>;

export const createFetchCloneTargetOrganizationsQueryFn =
  (call: TCall) =>
  async ({ queryKey: [{ email }], signal }: TParams) => {
    const options = { dontRedirectOnError: true, onError: () => undefined };
    const user = await call(
      () => cancelOnSignal(AdminService.getAdminUserProfileByEmail({ userEmail: email }), signal),
      options,
    );
    const [organizations, workspaces] = await Promise.all([
      call(() => cancelOnSignal(AdminService.getAdminUserOrganizationRelations({ userId: user.id }), signal), options),
      call(() => cancelOnSignal(AdminService.getAdminUserOrganizationWorkspaces({ userId: user.id }), signal), options),
    ]);
    return organizations.map((organization) => ({
      ...organization,
      workspaces: workspaces.filter((workspace) => workspace.organizationId === organization.id),
    }));
  };
